export const TURNSTILE_HEADER = "cf-turnstile-response";
export const BETTER_AUTH_CAPTCHA_HEADER = "x-captcha-response";
export const BETTER_AUTH_REFERRAL_HEADER = "x-referral-code";

export function buildTurnstileHeaders(
  turnstileToken: string | null | undefined
): Record<string, string> {
  const trimmed = turnstileToken?.trim() ?? "";
  if (!trimmed) {
    return {};
  }
  return {
    [TURNSTILE_HEADER]: trimmed,
    [BETTER_AUTH_CAPTCHA_HEADER]: trimmed,
  };
}

export function buildBetterAuthSignupHeaders(
  turnstileToken: string | null | undefined,
  referralCode?: string | null
): Record<string, string> {
  const headers = buildTurnstileHeaders(turnstileToken);
  const referral = referralCode?.trim().toLowerCase();
  if (referral) {
    headers[BETTER_AUTH_REFERRAL_HEADER] = referral;
  }
  return headers;
}

export function mergeTurnstileHeaders(
  headers: Record<string, string>,
  turnstileToken: string | null | undefined
): Record<string, string> {
  return { ...headers, ...buildTurnstileHeaders(turnstileToken) };
}
